import {
    Box,
    Text,
    Image,
    VStack,
    Heading
  } from '@chakra-ui/react'

  import GitHubCalendar from 'react-github-calendar';
import { ColorContext } from '../Context/ColorContext';
import { useContext } from 'react';

 

export const GithubStats = () => {
        const { colors, setColors, underLineColor, textColor, family } = useContext(ColorContext)


    return <Box pb = '50px' mt={['85%','65%','15%','15%']}>


      <Heading color = {colors} fontSize={['1.5rem','1.9rem','2.6rem','3.2rem']} textAlign={"center"} margin={"5% 0%"} > <Text as = 'span' color = 'black'>Github</Text> Calender</Heading>


          <VStack mt = '70px'>

            <GitHubCalendar username="bharat24862486"></GitHubCalendar>

          </VStack>


          <Heading mt ='50px' color = {colors} textAlign={"center"} margin={"5% 0%"} fontSize={['1.5rem','1.9rem','2.6rem','3.2rem']}> <Text as = 'span' color = 'black'>Github</Text> Stats</Heading>

          <VStack mt = '70px'>
              
                  <Image id="github-stats-card" borderRadius = '20px' src = 'https://github-readme-stats.vercel.app/api?username=bharat24862486&show_icons=true&locale=en'></Image>

          </VStack> 


          <Heading mt ='50px' color = {colors} textAlign={"center"} margin={"5% 0%"} fontSize={['1.5rem','1.9rem','2.6rem','3.2rem']}> <Text as = 'span' color = 'black'>Github</Text> Streaks</Heading>

          <VStack mt = '70px'>
              
                  <Image id="github-streak-stats" borderRadius = '20px' src = 'https://github-readme-streak-stats.herokuapp.com/?user=bharat24862486&'></Image>

          </VStack> 

          <Heading mt ='50px' color = {colors} textAlign={"center"} margin={"5% 0%"} fontSize={['1.5rem','1.9rem','2.6rem','3.2rem']}> <Text as = 'span' color = 'black'>Github</Text> Languages</Heading>

          <VStack mt = '70px'>
              
                  <Image id="github-top-langs" borderRadius = '20px' src = 'https://github-readme-stats.vercel.app/api/top-langs?username=bharat24862486&show_icons=true&locale=en&layout=compact'></Image>

          </VStack>


          

          

        </Box>

}